import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  role: null,
  jwtToken: null,
  userId: null,
  fname: null,
  lname: null,
  photo: null,
};

export const isAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthLogin: (state, actions) => {
      const { role, jwtToken, userId, fname } = actions.payload;
      state.role = role;
      state.jwtToken = jwtToken;
      state.userId = userId;
      state.fname = fname;
      state.role = role;
      state.jwtToken = jwtToken;
    },
    resetState: () => initialState,
  },
});

export const { setAuthLogin, resetState } = isAuthSlice.actions;

export default isAuthSlice.reducer;
